import React from 'react';
import classNames from 'classnames';

import { BadgeList } from '@wix/members-badge-lib';

import Avatar from '../avatar';
import Blocked from '../blocked';
import RoleIcons from '../../containers/role-icons';
import MemberMoreButton from '../member-more-button';
import { ActionButton } from '../action-button';
import { FFBoxProps } from '../../containers/ff-box';
import styles from './ff-box-mobile.scss';

export class FFBoxMobile extends React.Component<FFBoxProps> {
  render() {
    const {
      t,
      member,
      pictureStyle,
      rolesActions,
      showAsBlocked,
      isBlocked,
      showFollowers,
      badgesSettings,
      currentMemberUid,
      onRoleAction,
      goToMemberPage,
      followOrUnfollow,
      isRtlLocale,
    } = this.props;

    const containerClassName = classNames(styles.container, 'ma-ff-member-box', 'ma-ff-member-box-border-color');

    const navigateToMemberPage = () => {
      goToMemberPage(member.uid);
    };

    return (
      <div data-hook="memberBox" className={containerClassName}>
        <div className={styles.padding}>
          <div className={styles.avatarContainer} onClick={navigateToMemberPage}>
            <Avatar
              url={member.picture}
              dataHook="mobile-avatar"
              className={styles.avatar}
              layoutType={pictureStyle}
              name={member.name}
              isMobile={true}
            />
          </div>
          <div className={styles.detailsContainer} onClick={navigateToMemberPage}>
            <div className={styles.nameAndIcons}>
              <p className={classNames(styles.nameText, 'ma-members-name-font')}>{member.name}</p>
              <RoleIcons
                roles={member.roles}
                containerClassName={styles.roleIcons}
                iconClassName="ma-fill-primary-text"
              />
            </div>
            {showFollowers && !showAsBlocked && (
              <div className={classNames(styles.followContainer, 'ma-members-ff-font')}>
                <div className={classNames(styles.followItem, styles.marginRight)} data-hook="mb-followers">
                  <span>{member.followerCount} </span>
                  <span>{t('profile-widget.followers')}</span>
                </div>
                <div className={styles.followItem} data-hook="mb-following">
                  <span>{member.followingCount} </span>
                  <span>{t('profile-widget.following')}</span>
                </div>
              </div>
            )}
            {showAsBlocked && <Blocked className={classNames('ma-primary-font', styles.blockedMember)} />}
            <div className={styles.badgesContainer}>
              <BadgeList
                {...badgesSettings}
                size="tiny"
                align="left"
                layout="icon-only"
                maxRows={1}
                borderRadius={100}
                onClickMore={navigateToMemberPage}
                onBadgeClick={navigateToMemberPage}
              />
            </div>
          </div>

          {!isBlocked && (
            <ActionButton
              member={member}
              linkClassName={styles.actionBtn}
              goToMemberPage={goToMemberPage}
              currentMemberUid={currentMemberUid}
              followOrUnfollow={followOrUnfollow}
              containerClassName={styles.actionBtnContainer}
            />
          )}

          <MemberMoreButton
            member={member}
            rolesActions={rolesActions}
            onRoleAction={onRoleAction}
            containerClass={styles.moreBtnContainer}
            iconContainerClass={styles.iconContainer}
            isRtlLocale={isRtlLocale}
          />
        </div>
      </div>
    );
  }
}
